export function isScalar (val: unknown): boolean {
  if (val === undefined || val === null) {
    return true
  }
  const scalarTypes = ['string', 'number', 'boolean']
  return scalarTypes.includes(typeof val)
}
